import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const ClientsApp = lazy(() => import('./view/Clients'))
const CreditApp = lazy(() => import('./view/Credits'))

export const clientsRoutesMap = {
  clients: {
    path: '/clientes/gestion',
    name: 'Gestión de clientes',
    action: 'GESTION_DE_CLIENTES',
  },
  credits: {
    path: '/clientes/creditos',
    name: 'Líneas de crédito',
    action: 'LINEAS_DE_CREDITO',
  },
  administrar: {
    name: 'Administrar líneas de crédito',
    action: 'ADMINISTRAR_LINEAS_DE_CREDITO',
  },
}

const clientsRoutes = [
  {
    path: clientsRoutesMap.clients.path,
    element: (
      <OperacionesProvider>
        <ClientsApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: clientsRoutesMap.credits.path,
    element: (
      <OperacionesProvider>
        <CreditApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default clientsRoutes
